import { ReferralActivityDto } from 'common/api';

export const ReferralActivity = {
  STATUS_CHANGE: ReferralActivityDto.event.STATUS_CHANGE,
  NOTE_CHANGE: ReferralActivityDto.event.NOTE_CHANGE,
  FORWARD_TO_SITE: ReferralActivityDto.event.FORWARD_TO_SITE,
  RELOCATED: ReferralActivityDto.event.RELOCATED,
  VISIT_601_STATUS_CHANGE: ReferralActivityDto.event.VISIT_601_STATUS_CHANGE,
  SCREENER_PAUSED: ReferralActivityDto.event.SCREENER_PAUSED,
  SEQSTER_MR_STATUS: ReferralActivityDto.event.SEQSTER_MR_STATUS,
  SEQSTER_MR_CONSENT: ReferralActivityDto.event.SEQSTER_MR_CONSENT,
  SEQSTER_MR_LINK_REQUESTED:
    ReferralActivityDto.event.SEQSTER_MR_LINK_REQUESTED,
};

export type ReferralActivityType = keyof typeof ReferralActivity;
